import Vue from "vue";

Vue.component("notification-portal-viewer", {
    props: ["partyId", "yearFrom"],
    data() {
        return {
            showNotificationPortalInfo: false,
            years: [],
            fromYear: this.yearFrom != null ? this.yearFrom : 1996,
            toYear: (new Date().getFullYear() + 1),
            oldYearFrom: this.yearFrom != null ? this.yearFrom : 1996,
            oldYearTo: (new Date().getFullYear() + 1),
            showRefetch: false,
            notificationPortalInfoMessage: window.messages.notificationPortalViewerInitialization,
            isResettable: false,
            showNotificationModal: false,
            nonPeriodicBarData: {
                labels: [],
                datasets: []
            },
            parties: [],

            notificationModalTitle: null,
            notificationDomain: null,
            notificationRequirement: null,
            notificationInfos: [],

            statisticsTooltip: null,
            thresholdTooltip: null,
            legislationTooltip: null,
            modificationTooltip: null,
            publicationMediaTooltip: null,
            notificationPortalApi: window.urls.notificationPortalApi,
            lETDocumentRedirect: window.urls.lETDocumentRedirect,
            statisticsLoading: true,
            thresholdLoading: true,
            legislationLoading: true,
            modificationLoading: true,
            publicationMediaLoading: true,
            nonPeriodicLoading: true,

            overallCompliancePercentage: 0,
            overallCompliancePercentagePrecision: 0,
            overallCompliancePercentageWhole: 0,
            overallSubmittedNotificationCount: 0,
            overallNotificationTotal: 0,
            overallNonPeriodicSubmittedNotificationCount: 0,

            statisticsParties: [],
            statisticsPeriodIds: [],
            statisticsCompliances: [],
            statisticsCompliancePercentage: 0,
            statisticsCompliancePercentagePrecision: 0,
            statisticsCompliancePercentageWhole: 0,
            statisticsCompliancePercentageRemaining: 0,
            statisticsNotificationTotal: 0,
            statisticsSubmittedNotificationCount: 0,
            statisticsActualSubmittedNotificationCount: 0,
            statisticsNotifications: [],
            statisticsMissedNotifications: [],

            thresholdParties: [],
            thresholdPeriodIds: [],
            thresholdCompliances: [],
            thresholdCompliancePercentage: 0,
            thresholdCompliancePercentagePrecision: 0,
            thresholdCompliancePercentageWhole: 0,
            thresholdCompliancePercentageRemaining: 0,
            thresholdNotificationTotal: 0,
            thresholdSubmittedNotificationCount: 0,
            thresholdActualSubmittedNotificationCount: 0,
            thresholdNotifications: [],
            thresholdMissedNotifications: [],

            legislationParties: [],
            legislationSubmittedNotificationCount: 0,

            modificationParties: [],
            modificationSubmittedNotificationCount: 0,

            publicationMediaParties: [],
            publicationMediaSubmittedNotificationCount: 0,

            statisticsPeriodicNotifications: [],
            thresholdPeriodicNotifications: [],
            showIndividualNotificationPortalInfo: false,
            individualNotificationPortalInfoMessage: window.messages.notificationPortalViewerNoResult,
            individualPeriodId: 0,
            individualPartyId: '',
            individualRequirementId: 0,
            showRefetchOnModal: false,
            showCoverageDates: true,
            forPeriodic: true,
            notificationPortalData: []
        }
    },
    computed: {
        overallActualSubmittedNotificationCount: function () {
            return this.statisticsActualSubmittedNotificationCount + this.thresholdActualSubmittedNotificationCount;
        },
        notificationHeaderLabel: function () {
            return window.labels.notificationPortalHeader;
        },
        notificationPortalPeriodicHeaderLabel: function () {
            return window.labels.notificationPortalPeriodicHeader;
        },
        notificationPortalStatisticsHeaderLabel: function () {
            return window.labels.notificationPortalStatisticsHeader;
        },
        notificationPortalProcurementHeaderLabel: function () {
            return window.labels.notificationPortalProcurementHeader;
        },
        notificationPortalStatisticsObligationMessage: function () {
            return window.messages.notificationPortalStatisticsObligationMessage;
        },
        notificationPortalThresholdObligationMessage: function () {
            return window.messages.notificationPortalThresholdObligationMessage;
        },
        notificationPortalNonPeriodicHeaderLabel: function () {
            return window.labels.notificationPortalNonPeriodicHeader;
        },
        notificationPortalLegislationHeaderLabel: function () {
            return window.labels.notificationPortalLegislationHeader;
        },
        notificationPortalLegislationObligationMessage: function () {
            return window.messages.notificationPortalLegislationObligationMessage;
        },
        notificationPortalModificationHeaderLabel: function () {
            return window.labels.notificationPortalModificationHeader;
        },
        notificationPortalModificationObligationMessage: function () {
            return window.messages.notificationPortalModificationObligationMessage;
        },
        notificationPortalPublicationMediaHeaderLabel: function () {
            return window.labels.notificationPortalPublicationMediaHeader;
        },
        notificationPortalPublicationMediaObligationMessage: function () {
            return window.messages.notificationPortalPublicationMediaObligationMessage;
        },
        notificationPortalViewerRefreshDataMessage: function () {
            return window.messages.notificationPortalViewerRefreshData;
        },
        resetLabel: function () {
            return window.labels.reset;
        },
        notificationPortalviewerStatusNotificationSubmittedLabel: function () {
            return window.messages.notificationPortalviewerStatusNotificationSubmitted;
        },
        notificationPortalViewerNotificationSubmittedLabel: function () {
            return window.messages.notificationPortalViewerNotificationSubmitted;
        },
        notificationPortalViewerRefreshDataLabel: function () {
            return window.messages.notificationPortalViewerRefreshData;
        },
        notificationsLabel: function () {
            return window.messages.notifications;
        },
        notificationPortalViewerTotalNumberLabel: function () {
            return window.messages.notificationPortalViewerTotalNumber;
        },
        statusLabel: function () {
            return window.messages.status;
        },
        typeLabel: function () {
            return window.labels.type;
        },
        selectYearFromLabel: function () {
            return window.labels.selectYearFrom;
        },
        selectYearToLabel: function () {
            return window.labels.selectYearTo;
        },
        yearLabel: function () {
            return window.labels.year;
        },
        partyLabel: function () {
            return window.labels.party;
        },
        submittedLabel: function () {
            return window.labels.submitted;
        },
        notSubmittedLabel: function () {
            return window.labels.notSubmitted;
        },
        notificationSymbolLabel: function () {
            return window.labels.notificationSymbol;
        },
        communicationDateLabel: function () {
            return window.labels.communicationDate;
        }
    },
    mounted() {
        const self = this;

        self.loadNotificationData(true, false);
        self.loadYears();
        self.loadParties();
    },
    watch: {
        fromYear: function (value) {
            const self = this;

            if (value != null) {
                self.isResettable = value != self.oldYearFrom;
            }
        },
        toYear: function (value) {
            const self = this;

            if (value != null) {
                self.isResettable = value != self.oldYearTo;
            }
        }
    },
    methods: {
        loadYears() {
            const self = this;

            for (let index = self.oldYearFrom; index <= self.oldYearTo; index++) {
                self.years.push(index);
            }
        },
        loadParties() {
            const self = this;

            self.$services.parties.getAll({
                language: window.currentLanguage
            }).then((data) => {
                self.parties = data;
            });
        },
        loadNotificationData(includeNonPeriodic, refetch) {
            const self = this;

            if (refetch) {
                self.showRefetch = false;
                self.notificationPortalInfoMessage = window.messages.notificationPortalViewerRefetch;
            }
            else {
                self.notificationPortalInfoMessage = window.messages.notificationPortalViewerInitialization;
            }

            self.retrieveNotificationPortalData(includeNonPeriodic);
        },

        resetPeriodicDataPoints() {
            const self = this;

            self.statisticsLoading = true;
            self.thresholdLoading = true;

            self.overallCompliancePercentage = 0;
            self.overallCompliancePercentagePrecision = 0;
            self.overallCompliancePercentageWhole = 0;
            self.overallSubmittedNotificationCount = 0;
            self.overallNotificationTotal = 0;
            self.statisticsCompliancePercentage = 0;
            self.statisticsCompliancePercentagePrecision = 0;
            self.statisticsCompliancePercentageWhole = 0;
            self.statisticsCompliancePercentageRemaining = 0;
            self.statisticsNotificationTotal = 0;
            self.statisticsSubmittedNotificationCount = 0;
            self.statisticsActualSubmittedNotificationCount = 0;
            self.thresholdCompliancePercentage = 0;
            self.thresholdCompliancePercentagePrecision = 0;
            self.thresholdCompliancePercentageWhole = 0;
            self.thresholdCompliancePercentageRemaining = 0;
            self.thresholdNotificationTotal = 0;
            self.thresholdSubmittedNotificationCount = 0;
            self.thresholdActualSubmittedNotificationCount = 0;
            self.thresholdNotifications = [];
            self.thresholdMissedNotifications = [];
        },
        resetNonPeriodicDataPoints() {
            const self = this;

            self.legislationLoading = true;
            self.modificationLoading = true;
            self.publicationMediaLoading = true;
            self.nonPeriodicLoading = true;
            self.legislationSubmittedNotificationCount = 0;
            self.modificationSubmittedNotificationCount = 0;
            self.publicationMediaSubmittedNotificationCount = 0;
            self.overallNonPeriodicSubmittedNotificationCount = 0;
        },

        retrieveNotificationPortalData(includeNonPeriodic) {
            const self = this;

            self.resetPeriodicDataPoints();

            self.$services.notificationPortal.getAllNotifications({
                requirementIds: '150,244,178,245,246',
                yearFrom: self.fromYear,
                yearTo: self.toYear,
                partyId: self.partyId
            }).then((data) => {
                if (data != null) {
                    self.constructNotificationPeriodIds();

                    self.constructStatisticsStatus(data.statistics);

                    self.constructThresholdStatus(data.threshold);

                    self.getStatisticsNotificationCount(data.statistics);
                    self.getThresholdNotificationCount(data.threshold);

                    self.showNotificationPortalInfo = (self.statisticsPeriodIds != null && self.statisticsPeriodIds.length > 0) ||
                        (self.thresholdPeriodIds != null && self.thresholdPeriodIds.length > 0);

                    if (includeNonPeriodic) {
                        self.nonPeriodicLoading = true;
                        self.resetNonPeriodicDataPoints();
                        self.constructLegislationStatus(data.legislation);
                        self.constructModificationStatus(data.modification);
                        self.constructPublicationMediaStatus(data.publicationMedia);

                        self.getLegislationNotificationCount(data.legislation);
                        self.getModificationNotificationCount(data.modification);
                        self.getPublicationMediaNotificationCount(data.publicationMedia);

                        self.computeNonPeriodicOverall();

                        if (self.partyId == null) {
                            self.nonPeriodicBarData.labels = [];
                            self.nonPeriodicBarData.labels.push(window.labels.notifications);
                            self.nonPeriodicBarData.datasets = [];
                            self.plotNonPeriodicChart();
                        }
                    }
                }
                else {
                    self.showNotificationPortalInfo = false;
                    self.showRefetch = true;
                    self.notificationPortalInfoMessage = window.messages.notificationPortalViewerNoResultRetry;
                }
            });
        },
        constructNotificationPeriodIds() {
            const self = this;

            self.statisticsPeriodIds = [];
            self.thresholdPeriodIds = [];

            const currentYear = new Date().getFullYear();
            for (let year = self.fromYear; year <= self.toYear; year++) {
                self.statisticsPeriodIds.push({
                    id: '150-' + year.toString(),
                    label: year.toString(),
                    year: year,
                    forCompliance: (year <= (currentYear - window.statisticsForComplianceGracePeriodYear)),
                    forViewing: (year <= (currentYear - window.statisticsForViewingGracePeriodYear))
                });

                self.thresholdPeriodIds.push({
                    id: '244-' + year.toString(),
                    label: year.toString(),
                    year: year,
                    forCompliance: (year <= currentYear),
                    forViewing: (year <= (currentYear + window.thresholdForViewingAdvanceYear))
                });
            }
        },
        constructStatisticsStatusPeriods(periods) {
            const self = this;

            if (periods != null && periods.length > 0) {
                self.statisticsLoading = true;
                self.statisticsPeriodIds = [];

                const currentYear = new Date().getFullYear();
                periods.forEach(period => {
                    const convertedPeriod = parseInt(period.label);
                    if (convertedPeriod >= self.fromYear && convertedPeriod <= self.toYear) {
                        self.statisticsPeriodIds.push({
                            id: period.period_Id,
                            label: period.label,
                            year: convertedPeriod,
                            forCompliance: (convertedPeriod <= (currentYear - window.statisticsForComplianceGracePeriodYear)),
                            forViewing: (convertedPeriod <= (currentYear - window.statisticsForViewingGracePeriodYear))
                        });
                    }
                });
            }
        },
        constructStatisticsStatus(data) {
            const self = this;

            if (data != null) {

                self.statisticsTooltip = data.requirement.long_Name;

                const statuses = data.statuses != null && data.statuses.length > 0 ? data.statuses : [];

                if (statuses != null && statuses.length > 0) {
                    if (self.partyId == null) {
                        self.constructStatisticsStatusForAllParties(statuses);
                    }
                    else {
                        self.constructStatisticsStatusForParty(statuses);
                    }
                }
            }
        },
        constructStatisticsStatusForAllParties(statuses) {
            const self = this;

            self.statisticsParties = [];
            self.statisticsPeriodicNotifications = [];

            statuses.forEach(status => {

                const nonCompliants = [];
                const compliants = [];
                const exemptions = [];

                const partyId = status.member_Code == 'C528' ? 'C533' : status.member_Code;
                if (status.periods != null) {
                    self.statisticsPeriodIds.forEach(period => {
                        const notificationPeriod = status.periods[period.id];
                        if (notificationPeriod != null) {
                            if (period.forViewing) {
                                if (period.forCompliance) {
                                    if (notificationPeriod.notification == -1) {
                                        nonCompliants.push(period.id);
                                    }
                                    else if (notificationPeriod.notification == 1) {
                                        compliants.push(period.id);
                                    }
                                }
                                else {
                                    exemptions.push(period.id);

                                    if (notificationPeriod.notification == 1) {
                                        compliants.push(period.id);
                                    }
                                }

                                self.statisticsPeriodicNotifications.push({
                                    notification: notificationPeriod.notification,
                                    period_Id: notificationPeriod.period_Id,
                                    is_Eu: notificationPeriod.is_Eu,
                                    is_Lic: notificationPeriod.is_Lic,
                                    is_Wto: notificationPeriod.is_Wto,
                                    is_Otn: notificationPeriod.is_Otn,
                                    forCompliance: period.forCompliance,
                                    forViewing: period.forViewing
                                });
                            }
                        }
                    });
                }

                self.statisticsParties.push({
                    id: status.member_Code,
                    label: status.label,
                    nativeId: partyId,
                    exemptions: exemptions,
                    nonCompliantPeriods: nonCompliants,
                    compliantPeriods: compliants
                });
            });
            self.computeStatisticsData();
        },
        constructStatisticsStatusForParty(statuses) {
            const self = this;
            const partyId = self.partyId == 'C533' ? 'C528' : self.partyId;

            const status = statuses.filter(item => {
                return item.member_Code == partyId;
            });

            if (status[0] != null) {
                self.showNotificationPortalInfo = true;

                const nonCompliants = [];
                const compliants = [];
                const periods = status[0].periods;

                if (periods != null) {
                    let tempStatisticsCompliances = [];

                    self.statisticsPeriodIds.forEach(period => {
                        const notificationPeriod = periods[period.id];
                        if (notificationPeriod != null) {
                            if (notificationPeriod.is_Wto == 2 && notificationPeriod.is_Otn == 0) {
                                if (notificationPeriod.notification != 0) {
                                    if (notificationPeriod.notification == -1) {
                                        nonCompliants.push(period.id);
                                    }
                                    else if (notificationPeriod.notification == 1) {
                                        compliants.push(period.id);
                                    }

                                    tempStatisticsCompliances.push({
                                        year: period.label,
                                        yearInt: period.year,
                                        compliance: notificationPeriod.notification,
                                        partyId: partyId,
                                        periodId: period.id
                                    });
                                }
                            }
                        }
                    });

                    self.statisticsCompliances = tempStatisticsCompliances.sort((a, b) => {
                        return b.yearInt - a.yearInt;
                    });
                }

                self.statisticsMissedPeriod = nonCompliants;
                self.statisticsSubmittedPeriod = compliants;
                self.statisticsNotificationTotal = nonCompliants.length + compliants.length;
                self.statisticsSubmittedNotificationCount = compliants.length;
                const statisticsComputation = (self.statisticsSubmittedNotificationCount / self.statisticsNotificationTotal) * 100;
                const statisticsPercentage = isNaN(statisticsComputation) ? 0.0 : statisticsComputation;
                const statisticsRemaining = 100.00 - statisticsPercentage;

                self.statisticsCompliancePercentage = statisticsPercentage;
                self.statisticsCompliancePercentageRemaining = statisticsRemaining;
                self.statisticsCompliancePercentagePrecision = parseFloat(statisticsPercentage).toFixed(2);
                self.statisticsCompliancePercentageWhole = parseInt(statisticsPercentage);

                self.overallSubmittedNotificationCount = self.statisticsSubmittedNotificationCount + self.thresholdSubmittedNotificationCount;
                self.overallNotificationTotal = self.statisticsNotificationTotal + self.thresholdNotificationTotal;

                const overallStatisticsComputation = (self.overallSubmittedNotificationCount / self.overallNotificationTotal) * 100;
                const overallStatisticsPercentage = isNaN(overallStatisticsComputation) ? 0 : overallStatisticsComputation;

                self.overallCompliancePercentagePrecision = parseFloat(overallStatisticsPercentage).toFixed(2);
                self.overallCompliancePercentageWhole = parseInt(overallStatisticsPercentage);

                self.statisticsLoading = false;
            }
        },
        computeStatisticsData() {
            const self = this;

            self.statisticsNotifications = self.statisticsPeriodicNotifications.filter(item => {
                return (item.notification == -1 || item.notification == 1) && item.forViewing;
            });

            const statisticsNotificationsForCompliance = self.statisticsPeriodicNotifications.filter(item => {
                return (item.notification == -1 || item.notification == 1) && item.forCompliance;
            });

            self.statisticsNotificationTotal = statisticsNotificationsForCompliance.length;

            const statisticsSubmittedNotifications = statisticsNotificationsForCompliance.filter(item => {
                return item.notification == 1;
            });

            self.statisticsSubmittedNotificationCount = statisticsSubmittedNotifications.length;

            const computation = (self.statisticsSubmittedNotificationCount / self.statisticsNotificationTotal) * 100;
            const percentage = isNaN(computation) ? 0 : computation;
            const remaining = 100.00 - percentage;

            self.statisticsCompliancePercentagePrecision = parseFloat(percentage).toFixed(2);
            self.statisticsCompliancePercentageWhole = parseInt(percentage);
            self.statisticsCompliancePercentage = percentage;
            self.statisticsCompliancePercentageText = percentage.toString();
            self.statisticsCompliancePercentageRemaining = remaining;
            self.statisticsCompliancePercentageRemainingText = remaining.toString();

            if (self.statisticsNotifications.length > 0) {
                self.loadStatisticsCompliance();
                self.statisticsLoading = false;
            }
        },
        loadStatisticsCompliance() {
            const self = this;

            self.statisticsCompliances = [];
            let tempStatisticsCompliances = [];
            self.statisticsPeriodIds.forEach(period => {
                if (period.forViewing) {
                    const periodicStatisticNotifications = self.statisticsNotifications.filter(item => {
                        return item.period_Id == period.id && item.forCompliance;
                    });

                    const periodicStatisticSubmittedNotifications = periodicStatisticNotifications.filter(item => {
                        return item.notification == 1;
                    });

                    let nonCompliantMembers = [];
                    let compliantMembers = [];
                    let exemptions = [];

                    self.statisticsParties.forEach(party => {
                        if (party.exemptions.indexOf(period.id) >= 0) {
                            exemptions.push(period.id);
                        }

                        if (party.nonCompliantPeriods.indexOf(period.id) >= 0) {
                            const nonCompliantParty = self.parties.filter(item => {
                                return item.id == party.nativeId;
                            });

                            if (nonCompliantParty[0] != null) {
                                nonCompliantMembers.push(nonCompliantParty[0].iso3a.trim());
                            }
                        }

                        if (party.compliantPeriods.indexOf(period.id) >= 0) {
                            const compliantParty = self.parties.filter(item => {
                                return item.id == party.nativeId;
                            });

                            if (compliantParty[0] != null) {
                                compliantMembers.push(compliantParty[0].iso3a.trim());
                            }
                        }
                    });

                    let computation = 0;
                    let percentage = 0;
                    let remaining = 0;
                    let submittedCount = periodicStatisticSubmittedNotifications.length;
                    let total = periodicStatisticNotifications.length;

                    if (periodicStatisticNotifications.length > 0) {
                        computation = (submittedCount / total) * 100;
                        percentage = isNaN(computation) ? 0.0 : computation;
                        remaining = 100.00 - percentage;
                    }

                    tempStatisticsCompliances.push({
                        year: period.label,
                        yearInt: parseInt(period.label),
                        total: total,
                        exempted: exemptions.length > 0,
                        submitted: submittedCount,
                        percentage: percentage,
                        remaining: remaining,
                        nonCompliants: nonCompliantMembers.join(', '),
                        compliants: compliantMembers.join(', ')
                    });
                }
            });

            self.statisticsCompliances = tempStatisticsCompliances.sort((a, b) => {
                return b.yearInt - a.yearInt;
            });
        },
        constructThresholdStatusPeriods(periods) {
            const self = this;

            if (periods != null && periods.length > 0) {
                self.thresholdLoading = true;
                self.thresholdPeriodIds = [];

                const currentYear = new Date().getFullYear();
                periods.forEach(period => {
                    const convertedPeriod = parseInt(period.label);
                    if (convertedPeriod >= self.fromYear && convertedPeriod <= self.toYear) {
                        self.thresholdPeriodIds.push({
                            id: period.period_Id,
                            label: period.label,
                            year: convertedPeriod,
                            forCompliance: (convertedPeriod <= currentYear),
                            forViewing: (convertedPeriod <= (currentYear + window.thresholdForViewingAdvanceYear))
                        });
                    }
                });
            }
        },
        constructThresholdStatus(data) {
            const self = this;

            if (data != null) {
                self.thresholdTooltip = data.requirement.long_Name;

                const statuses = data.statuses != null && data.statuses.length > 0 ? data.statuses : [];

                if (statuses != null && statuses.length > 0) {
                    if (self.partyId == null) {
                        self.constructThresholdStatusForAllParties(statuses);
                    }
                    else {
                        self.constructThresholdStatusForParty(statuses);
                    }
                }
            }
        },
        constructThresholdStatusForAllParties(statuses) {
            const self = this;

            self.thresholdParties = [];
            self.thresholdPeriodicNotifications = [];

            statuses.forEach(status => {

                const nonCompliants = [];
                const compliants = [];
                const exemptions = [];

                const partyId = status.member_Code == 'C528' ? 'C533' : status.member_Code;

                if (status.periods != null) {

                    self.thresholdPeriodIds.forEach(period => {
                        const notificationPeriod = status.periods[period.id];

                        if (notificationPeriod != null) {
                            if (period.forViewing) {
                                if (period.forCompliance) {
                                    if (notificationPeriod.notification == -1) {
                                        nonCompliants.push(period.id);
                                    }
                                    else if (notificationPeriod.notification == 1) {
                                        compliants.push(period.id);
                                    }
                                }
                                else {
                                    exemptions.push(period.id);

                                    if (notificationPeriod.notification == 1) {
                                        compliants.push(period.id);
                                    }
                                }

                                self.thresholdPeriodicNotifications.push({
                                    notification: notificationPeriod.notification,
                                    period_Id: notificationPeriod.period_Id,
                                    is_Eu: notificationPeriod.is_Eu,
                                    is_Lic: notificationPeriod.is_Lic,
                                    is_Wto: notificationPeriod.is_Wto,
                                    is_Otn: notificationPeriod.is_Otn,
                                    forCompliance: period.forCompliance,
                                    forViewing: period.forViewing
                                });
                            }
                        }
                    });
                }

                self.thresholdParties.push({
                    id: status.member_Code,
                    label: status.label,
                    nativeId: partyId,
                    exemptions: exemptions,
                    nonCompliantPeriods: nonCompliants,
                    compliantPeriods: compliants
                });
            });

            self.computeThresholdData();
        },
        constructThresholdStatusForParty(statuses) {
            const self = this;
            const partyId = self.partyId == 'C533' ? 'C528' : self.partyId;

            const status = statuses.filter(item => {
                return item.member_Code == partyId;
            });

            if (status[0] != null) {
                self.showNotificationPortalInfo = true;

                const nonCompliants = [];
                const compliants = [];
                const periods = status[0].periods;

                if (periods != null) {

                    let tempThresholdCompliances = [];

                    self.thresholdPeriodIds.forEach(period => {
                        if (period.forViewing) {
                            const notificationPeriod = periods[period.id];

                            if (notificationPeriod != null) {
                                if (notificationPeriod.is_Wto == 2 && notificationPeriod.is_Otn == 0) {
                                    if (notificationPeriod.notification != 0) {

                                        if (period.forCompliance) {
                                            if (notificationPeriod.notification == -1) {
                                                nonCompliants.push(period.id);
                                            }
                                            else if (notificationPeriod.notification == 1) {
                                                compliants.push(period.id);
                                            }
                                        }

                                        tempThresholdCompliances.push({
                                            year: period.label,
                                            yearInt: parseInt(period.label),
                                            compliance: notificationPeriod.notification,
                                            partyId: partyId,
                                            periodId: period.id
                                        });
                                    }
                                }
                            }
                        }
                    });

                    self.thresholdCompliances = tempThresholdCompliances.sort((a, b) => {
                        return b.yearInt - a.yearInt;
                    });
                }

                self.thresholdMissedPeriod = nonCompliants;
                self.thresholdSubmittedPeriod = compliants;
                self.thresholdNotificationTotal = Math.round((nonCompliants.length + compliants.length) / 2);
                self.thresholdSubmittedNotificationCount = Math.round(compliants.length / 2);

                const thresholdComputation = (self.thresholdSubmittedNotificationCount / self.thresholdNotificationTotal) * 100;
                const thresholdPercentage = isNaN(thresholdComputation) ? 0.0 : thresholdComputation;
                const thresholdRemaining = 100.00 - thresholdPercentage;

                self.thresholdCompliancePercentage = thresholdPercentage;
                self.thresholdCompliancePercentageRemaining = thresholdRemaining;
                self.thresholdCompliancePercentagePrecision = parseFloat(thresholdPercentage).toFixed(2);
                self.thresholdCompliancePercentageWhole = parseInt(thresholdPercentage);

                self.overallSubmittedNotificationCount = self.statisticsSubmittedNotificationCount + self.thresholdSubmittedNotificationCount;

                self.overallNotificationTotal = self.statisticsNotificationTotal + self.thresholdNotificationTotal;
                const overallThresholdComputation = (self.overallSubmittedNotificationCount / self.overallNotificationTotal) * 100;
                const overallThresholdPercentage = isNaN(overallThresholdComputation) ? 0 : overallThresholdComputation;

                self.overallCompliancePercentagePrecision = parseFloat(overallThresholdPercentage).toFixed(2);
                self.overallCompliancePercentageWhole = parseInt(overallThresholdPercentage);

                self.thresholdLoading = false;
            }
        },
        computeThresholdData() {
            const self = this;

            self.thresholdNotifications = self.thresholdPeriodicNotifications.filter(item => {
                return (item.notification == -1 || item.notification == 1) && item.forViewing;
            });

            const thresholdNotificationsForCompliance = self.thresholdPeriodicNotifications.filter(item => {
                return (item.notification == -1 || item.notification == 1) && item.forCompliance;
            });

            self.thresholdNotificationTotal = Math.round(thresholdNotificationsForCompliance.length / 2);

            const thresholdSubmittedNotifications = thresholdNotificationsForCompliance.filter(item => {
                return item.notification == 1;
            });


            self.thresholdSubmittedNotificationCount = Math.round(thresholdSubmittedNotifications.length / 2);

            const computation = (self.thresholdSubmittedNotificationCount / self.thresholdNotificationTotal) * 100;
            const percentage = isNaN(computation) ? 0 : computation;
            const remaining = 100.00 - percentage;

            self.thresholdCompliancePercentagePrecision = parseFloat(percentage).toFixed(2);
            self.thresholdCompliancePercentageWhole = parseInt(percentage);
            self.thresholdCompliancePercentage = percentage;
            self.thresholdCompliancePercentageText = percentage.toString();
            self.thresholdCompliancePercentageRemaining = remaining;
            self.thresholdCompliancePercentageRemainingText = remaining.toString();

            self.overallSubmittedNotificationCount = self.statisticsSubmittedNotificationCount + self.thresholdSubmittedNotificationCount;
            self.overallNotificationTotal = self.statisticsNotificationTotal + self.thresholdNotificationTotal;

            const overallComputation = (self.overallSubmittedNotificationCount / self.overallNotificationTotal) * 100;
            const overallPercentage = isNaN(overallComputation) ? 0 : overallComputation;

            self.overallCompliancePercentagePrecision = parseFloat(overallPercentage).toFixed(2);
            self.overallCompliancePercentageWhole = parseInt(overallPercentage);

            if (self.thresholdNotifications.length > 0) {
                self.loadThresholdCompliance();
                self.thresholdLoading = false;
            }
        },
        loadThresholdCompliance() {
            const self = this;

            self.thresholdCompliances = [];
            let tempThresholdCompliances = [];

            self.thresholdPeriodIds.forEach(period => {
                if (period.forViewing) {
                    const periodicThresholdNotifications = self.thresholdNotifications.filter(item => {
                        return item.period_Id == period.id && item.forCompliance;
                    });

                    const periodicThresholdSubmittedNotifications = periodicThresholdNotifications.filter(item => {
                        return item.notification == 1;
                    });

                    let nonCompliantMembers = [];
                    let compliantMembers = [];
                    let exemptions = [];

                    self.thresholdParties.forEach(party => {
                        if (party.exemptions.indexOf(period.id) >= 0) {
                            exemptions.push(period.id);
                        }

                        if (party.nonCompliantPeriods.indexOf(period.id) >= 0) {
                            const nonCompliantParty = self.parties.filter(item => {
                                return item.id == party.nativeId;
                            });

                            if (nonCompliantParty[0] != null) {
                                nonCompliantMembers.push(nonCompliantParty[0].iso3a.trim());
                            }
                        }

                        if (party.compliantPeriods.indexOf(period.id) >= 0) {
                            const compliantParty = self.parties.filter(item => {
                                return item.id == party.nativeId;
                            });

                            if (compliantParty[0] != null) {
                                compliantMembers.push(compliantParty[0].iso3a.trim());
                            }
                        }
                    });

                    let periodicThresholdSubmittedNotificationCount = 0;
                    let periodicThresholdNotificationTotal = 0;
                    let computation = 0;
                    let percentage = 0;
                    let remaining = 0;
                    let submittedCount = periodicThresholdSubmittedNotifications.length;
                    let total = periodicThresholdNotifications.length;

                    if (periodicThresholdNotifications.length > 0) {
                        periodicThresholdSubmittedNotificationCount = Math.round(periodicThresholdSubmittedNotifications.length / 2);
                        periodicThresholdNotificationTotal = Math.round(periodicThresholdNotifications.length / 2);
                        computation = (periodicThresholdSubmittedNotificationCount / periodicThresholdNotificationTotal) * 100;
                        percentage = isNaN(computation) ? 0.0 : computation;
                        remaining = 100.00 - percentage;
                    }

                    tempThresholdCompliances.push({
                        year: period.label,
                        yearInt: parseInt(period.label),
                        total: total,
                        exempted: exemptions.length > 0,
                        submitted: submittedCount,
                        percentage: percentage,
                        remaining: remaining,
                        nonCompliants: nonCompliantMembers.join(', '),
                        compliants: compliantMembers.join(', ')
                    });
                }
            });

            self.thresholdCompliances = tempThresholdCompliances.sort((a, b) => {
                return b.yearInt - a.yearInt;
            });
        },
        constructLegislationStatus(data) {
            const self = this;

            if (data != null) {
                if (self.partyId == null) {
                    self.constructLegislationStatusForAllParties(data);
                }
                else {
                    self.constructLegislationStatusForParty(data);
                }
            }
        },
        constructLegislationStatusForAllParties(data) {
            const self = this;

            self.legislationLoading = true;
            self.legislationParties = [];
            self.legislationTooltip = data.requirement.long_Name;

            const statuses = data.statuses != null && data.statuses.length > 0 ? data.statuses : [];

            statuses.forEach(status => {
                const partyId = status.member_Code == 'C528' ? 'C533' : status.member_Code;

                if (status.periods != null) {
                    const notificationPeriod = status.periods['178'];
                    if (notificationPeriod != null) {
                        const submitted = notificationPeriod.notification == 2;

                        self.legislationParties.push({
                            id: status.member_Code,
                            label: status.label,
                            nativeId: partyId,
                            submitted: submitted,
                            periodId: 178
                        })
                    }
                }
            });
        },
        constructLegislationStatusForParty(data) {
            const self = this;

            if (data != null) {
                self.legislationTooltip = `${data.requirement.long_Name}. ${self.notificationPortalLegislationObligationMessage}`;

                const statuses = data.statuses != null && data.statuses.length > 0 ? data.statuses : [];
                const partyId = self.partyId == 'C533' ? 'C528' : self.partyId;

                const status = statuses.filter(item => {
                    return item.member_Code == partyId;
                });

                if (status[0] != null) {
                    self.showNotificationPortalInfo = true;
                }
            }
        },
        constructModificationStatus(data) {
            const self = this;

            if (data != null) {
                if (self.partyId == null) {
                    self.constructModificationStatusForAllParties(data);
                }
                else {
                    self.constructModificationStatusForParty(data);
                }
            }
        },
        constructModificationStatusForAllParties(data) {
            const self = this;

            self.modificationLoading = true;
            self.modificationParties = [];
            self.modificationTooltip = data.requirement.long_Name;

            const statuses = data.statuses != null && data.statuses.length > 0 ? data.statuses : [];

            statuses.forEach(status => {
                const partyId = status.member_Code == 'C528' ? 'C533' : status.member_Code;

                if (status.periods != null) {
                    const notificationPeriod = status.periods['245'];
                    if (notificationPeriod != null) {
                        const submitted = notificationPeriod.notification == 2;

                        self.modificationParties.push({
                            id: status.member_Code,
                            label: status.label,
                            nativeId: partyId,
                            submitted: submitted,
                            periodId: 245
                        })
                    }
                }
            });
        },
        constructModificationStatusForParty(data) {
            const self = this;

            if (data != null) {
                self.modificationTooltip = `${data.requirement.long_Name}. ${self.notificationPortalModificationObligationMessage}`;

                const statuses = data.statuses != null && data.statuses.length > 0 ? data.statuses : [];
                const partyId = self.partyId == 'C533' ? 'C528' : self.partyId;

                const status = statuses.filter(item => {
                    return item.member_Code == partyId;
                });

                if (status[0] != null) {
                    self.showNotificationPortalInfo = true;
                }
            }
        },
        constructPublicationMediaStatus(data) {
            const self = this;

            if (data != null) {
                if (self.partyId == null) {
                    self.constructPublicationMediaStatusForAllParties(data);
                }
                else {
                    self.constructPublicationMediaStatusForParty(data);
                }
            }
        },
        constructPublicationMediaStatusForAllParties(data) {
            const self = this;

            self.publicationMediaLoading = true;
            self.publicationMediaParties = [];
            self.publicationMediaTooltip = data.requirement.long_Name;
            const statuses = data.statuses != null && data.statuses.length > 0 ? data.statuses : [];

            statuses.forEach(status => {
                const partyId = status.member_Code == 'C528' ? 'C533' : status.member_Code;

                if (status.periods != null) {
                    const notificationPeriod = status.periods['246'];
                    if (notificationPeriod != null) {
                        const submitted = notificationPeriod.notification == 2;

                        self.publicationMediaParties.push({
                            id: status.member_Code,
                            label: status.label,
                            nativeId: partyId,
                            submitted: submitted,
                            periodId: 246
                        })
                    }
                }
            });
        },
        constructPublicationMediaStatusForParty(data) {
            const self = this;

            if (data != null) {
                self.publicationMediaTooltip = `${data.requirement.long_Name}. ${self.notificationPortalPublicationMediaObligationMessage}`;

                const statuses = data.statuses != null && data.statuses.length > 0 ? data.statuses : [];
                const partyId = self.partyId == 'C533' ? 'C528' : self.partyId;

                const status = statuses.filter(item => {
                    return item.member_Code == partyId;
                });

                if (status[0] != null) {
                    self.showNotificationPortalInfo = true;
                }
            }
        },
        getStatisticsNotificationCount(data) {
            const self = this;

            const compliancePeriods = self.statisticsPeriodIds.filter(item => {
                return item.forCompliance;
            });

            const partyId = self.partyId;

            if (compliancePeriods != null && compliancePeriods.length > 0) {
                compliancePeriods.forEach(item => {
                    let notifications;

                    if (partyId == null) {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year;
                        });
                    }
                    else {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year && notification.memberCode == partyId;
                        });
                    }

                    self.statisticsActualSubmittedNotificationCount = self.statisticsActualSubmittedNotificationCount + notifications.length;
                });
            }
        },
        getThresholdNotificationCount(data) {
            const self = this;

            const compliancePeriods = self.thresholdPeriodIds.filter(item => {
                return item.forCompliance;
            });

            const partyId = self.partyId;

            if (compliancePeriods != null && compliancePeriods.length > 0) {
                compliancePeriods.forEach(item => {
                    let notifications;

                    if (partyId == null) {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year;
                        });
                    }
                    else {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year && notification.memberCode == partyId;
                        });
                    }

                    self.thresholdActualSubmittedNotificationCount = self.thresholdActualSubmittedNotificationCount + notifications.length;
                });
            }
        },
        getLegislationNotificationCount(data) {
            const self = this;

            const compliancePeriods = self.thresholdPeriodIds.filter(item => {
                return item.forCompliance;
            });

            const partyId = self.partyId;

            if (compliancePeriods != null && compliancePeriods.length > 0) {
                compliancePeriods.forEach(item => {
                    let notifications;

                    if (partyId == null) {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year;
                        });
                    }
                    else {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year && notification.memberCode == partyId;
                        });
                    }

                    self.legislationSubmittedNotificationCount = self.legislationSubmittedNotificationCount + notifications.length;
                    self.legislationLoading = false;
                });
            }
        },
        getModificationNotificationCount(data) {
            const self = this;

            const compliancePeriods = self.thresholdPeriodIds.filter(item => {
                return item.forCompliance;
            });

            const partyId = self.partyId;

            if (compliancePeriods != null && compliancePeriods.length > 0) {
                compliancePeriods.forEach(item => {
                    let notifications;

                    if (partyId == null) {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year;
                        });
                    }
                    else {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year && notification.memberCode == partyId;
                        });
                    }

                    self.modificationSubmittedNotificationCount = self.modificationSubmittedNotificationCount + notifications.length;
                    self.modificationLoading = false;
                });
            }
        },
        getPublicationMediaNotificationCount(data) {
            const self = this;

            const compliancePeriods = self.thresholdPeriodIds.filter(item => {
                return item.forCompliance;
            });

            const partyId = self.partyId;

            if (compliancePeriods != null && compliancePeriods.length > 0) {
                compliancePeriods.forEach(item => {
                    let notifications;

                    if (partyId == null) {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year;
                        });
                    }
                    else {
                        notifications = data.notifications.filter(notification => {
                            return notification.notificationYear == item.year && notification.memberCode == partyId;
                        });
                    }

                    self.publicationMediaSubmittedNotificationCount = self.publicationMediaSubmittedNotificationCount + notifications.length;
                    self.publicationMediaLoading = false;
                });
            }
        },
        computeNonPeriodicOverall() {
            const self = this;

            self.overallNonPeriodicSubmittedNotificationCount = self.legislationSubmittedNotificationCount +
                self.modificationSubmittedNotificationCount +
                self.publicationMediaSubmittedNotificationCount;

            self.nonPeriodicLoading = false;
        },
        plotNonPeriodicChart() {
            const self = this;

            const legislationData = [];
            legislationData.push(self.legislationSubmittedNotificationCount);

            self.nonPeriodicBarData.datasets.push({
                label: window.labels.domesticLegislations,
                backgroundColor: '#387ADF',
                data: legislationData
            });

            let modificationData = [];
            modificationData.push(self.modificationSubmittedNotificationCount);

            self.nonPeriodicBarData.datasets.push({
                label: window.labels.modificationsCoverage,
                backgroundColor: '#A5DD9B',
                data: modificationData
            });

            let publicationMediaData = [];
            publicationMediaData.push(self.publicationMediaSubmittedNotificationCount);

            self.nonPeriodicBarData.datasets.push({
                label: window.labels.modificationsPublicationMedia,
                backgroundColor: '#FFF67E',
                data: publicationMediaData
            });
        },
        resetFilter() {
            const self = this;
            self.isResettable = false;

            self.fromYear = self.oldYearFrom;
            self.toYear = self.oldYearTo;
            self.loadNotificationData(false, false);
        },
        closeModal() {
            this.showNotificationModal = false;
        },
        loadNotificationPortalInfo(requirementId, partyId, periodId, showModal, periodic) {
            const self = this;

            self.forPeriodic = periodic;
            self.showCoverageDates = periodic;
            self.individualRequirementId = requirementId;
            self.individualPartyId = partyId;
            self.individualPeriodId = periodId;

            self.retrieveNotificationPortalInfo(requirementId, partyId, periodId, periodic, showModal);
        },
        retrieveNotificationPortalInfo(requirementId, partyId, periodId, usePeriodInTitle, showModal) {
            const self = this;

            self.showIndividualNotificationPortalInfo = false;
            self.showRefetchOnModal = false;

            if (showModal) {
                self.showNotificationModal = true;
            }

            self.$services.notificationPortal.getNotification({
                requirementId: requirementId,
                language: window.currentLanguage,
                partyId: partyId,
                periodId: periodId
            }).then((data) => {
                if (data != null) {
                    self.notificationInfos = [];
                    self.notificationModalTitle = usePeriodInTitle ? `${data.member.name} @ ${data.period.label}` : data.member.name;
                    self.notificationDomain = data.period.domain;
                    self.notificationRequirement = data.period.requirement;

                    const sortedNotifications = data.notifications.sort((a, b) => {
                        return new Date(b.communicationDate) - new Date(a.communicationDate);
                    });

                    sortedNotifications.forEach(item => {
                        let url = '';
                        if (self.lETDocumentRedirect != null || self.lETDocumentRedirect != undefined) {
                            let upperCaseLanguage = 'ENGLISH';
                            switch (window.currentLanguage) {
                                case 1:
                                default:
                                    upperCaseLanguage = 'ENGLISH';
                                    break;
                                case 2:
                                    upperCaseLanguage = 'FRENCH';
                                    break;
                                case 3:
                                    upperCaseLanguage = 'SPANISH';
                                    break;
                            }

                            url = self.lETDocumentRedirect.replace('{0}', item.notificationSymbol);
                            url = url.replace('{1}', upperCaseLanguage);
                        }

                        self.notificationInfos.push({
                            notificationSymbol: item.notificationSymbol,
                            notificationSymbolLink: url,
                            communicationDate: moment(item.communicationDate).format("DD-MM-yyyy"),
                            coverage: moment(item.coverageDateStart).format("DD-MM-yyyy") + ' - ' + moment(item.coverageDateEnd).format("DD-MM-yyyy")
                        });

                        self.showIndividualNotificationPortalInfo = true;
                        self.showRefetchOnModal = false;
                    });
                }
                else {
                    self.individualNotificationPortalInfoMessage = window.messages.notificationPortalViewerNoResultRetry;
                    self.notificationModalTitle = window.labels.wtoNotificationsPortalIssue;
                    self.showRefetchOnModal = true;
                }
            });
        }
    },
    template: `
            <div>
                <div>
                    <section class="card" v-if="showNotificationPortalInfo">
                        <header class="card-header">
                            <h1 class="card-header-title">{{notificationHeaderLabel}}</h1>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <b-tabs>
                                    <b-tab-item :label="notificationPortalPeriodicHeaderLabel">
                                        <div class="columns is-gapless" v-if="years != null && years.length > 0">
                                            <div class="column mb-2">
                                                <b-field grouped multilined expanded class="pr-2">
                                                    <b-field label="Year From"></b-field>
                                                    <b-select expanded :placeholder="selectYearFromLabel" v-model="fromYear">
                                                        <option v-for="year in years"
                                                                :value="year"
                                                                :key="'yearFrom_' + year"> {{ year }}</option>
                                                    </b-select>
                                                </b-field>
                                            </div>
                                            <div class="column mb-2">
                                                <b-field grouped multilined expanded class="pr-2">
                                                    <b-field label="Year To"></b-field>
                                                    <b-select expanded :placeholder="selectYearToLabel" v-model="toYear">
                                                        <option v-for="year in years"
                                                                :value="year"
                                                                :key="'yearTo_' + year"> {{ year }}</option>
                                                    </b-select>
                                                </b-field>                                                
                                            </div>
                                            <div class="column mb-2 pr-2">
                                                <b-button expanded type="is-link is-primary" @click="loadNotificationData(false, false)">{{notificationPortalViewerRefreshDataMessage}}</b-button>
                                            </div>
                                            <div class="column mb-2">                                                
                                                <b-button expanded v-if="isResettable" type="is-link is-danger" @click="resetFilter">{{resetLabel}}</b-button>
                                            </div>
                                        </div>
                                        <template v-if="statisticsLoading || thresholdLoading"><loading></loading></template>
                                        <template v-else>
                                            <div class="columns">
                                                <div class="column is-3 has-text-centered">
                                                    <circle-counter size="10rem"
                                                                    :text="overallCompliancePercentagePrecision + '%'"
                                                                    :style="{'font-size': 'xx-large'}"
                                                                    :dash-count="100"
                                                                    :active-count="overallCompliancePercentageWhole"
                                                                    :active-width="40">
                                                    </circle-counter>
                                                    <h6>{{notificationPortalviewerStatusNotificationSubmittedLabel}}</h6>
                                                    <span style="font-weight: bold; font-size: x-large">{{overallActualSubmittedNotificationCount}} {{notificationPortalViewerNotificationSubmittedLabel}}</span>
                                                </div>
                                                <div class="column is-9">
                                                    <div class="table-wrapper has-mobile-cards">
                                                        <table class="table is-fullwidth is-striped">
                                                            <thead>
                                                                <tr>
                                                                    <td style="font-weight: bold">{{typeLabel}}</td>
                                                                    <td style="font-weight: bold">{{statusLabel}}</td>
                                                                    <td style="font-weight: bold">{{notificationsLabel}}</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <b-tooltip class="custom"
                                                                                    type="is-success"
                                                                                    :label="statisticsTooltip"
                                                                                    position="is-left"
                                                                                    multilined>
                                                                            <b-icon size="is-small" icon="info-circle"></b-icon>
                                                                        </b-tooltip>
                                                                        {{notificationPortalStatisticsHeaderLabel}}
                                                                    </td>
                                                                    <td width="300">
                                                                        <b-progress size="is-large" format="percent" :max="100" locale="en">
                                                                            <template #bar v-if="statisticsCompliancePercentage < 100">
                                                                                <b-progress-bar locale="en" :value="statisticsCompliancePercentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                                <b-progress-bar locale="en" :value="statisticsCompliancePercentageRemaining" :precision="2" show-value type="is-danger"></b-progress-bar>
                                                                            </template>
                                                                            <template #bar v-else>
                                                                                <b-progress-bar locale="en" :value="statisticsCompliancePercentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                            </template>
                                                                        </b-progress>
                                                                    </td>                                                                
                                                                    <td><span style="font-weight: bold">{{statisticsActualSubmittedNotificationCount}}</span></td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <b-tooltip class="custom"
                                                                                    type="is-success"
                                                                                    :label="thresholdTooltip"
                                                                                    position="is-left"
                                                                                    multilined>
                                                                            <b-icon size="is-small" icon="info-circle"></b-icon>
                                                                        </b-tooltip>
                                                                        {{notificationPortalProcurementHeaderLabel}}
                                                                    </td>
                                                                    <td width="300">
                                                                        <b-progress size="is-large" format="percent" :max="100" locale="en">
                                                                            <template #bar v-if="thresholdCompliancePercentage < 100">
                                                                                <b-progress-bar locale="en" :value="thresholdCompliancePercentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                                <b-progress-bar locale="en" :value="thresholdCompliancePercentageRemaining" :precision="2" show-value type="is-danger"></b-progress-bar>
                                                                            </template>
                                                                            <template #bar v-else>
                                                                                <b-progress-bar locale="en" :value="thresholdCompliancePercentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                            </template>
                                                                        </b-progress>
                                                                    </td>                                                                
                                                                    <td><span style="font-weight: bold">{{thresholdActualSubmittedNotificationCount}}</span></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="columns">
                                            <div class="column">
                                                <b-tabs>
                                                    <b-tab-item>
                                                        <template #header>
                                                            <span>
                                                                {{notificationPortalStatisticsHeaderLabel}}
                                                                <b-tag rounded type="is-info" size="is-large"> {{statisticsCompliancePercentagePrecision}}% </b-tag>
                                                            </span>
                                                        </template>
                                                        <template v-if="statisticsLoading"><loading></loading></template>
                                                        <template v-else>
                                                            <b-message type="is-success" class="mb-3">
                                                                {{notificationPortalStatisticsObligationMessage}}
                                                            </b-message>
                                                            <div class="columns">
                                                                <div class="column">
                                                                    <h6>{{notificationPortalviewerStatusNotificationSubmittedLabel}}</h6>
                                                                    <b-progress size="is-large" format="percent" :max="100" locale="en" class="mb-5">
                                                                        <template #bar v-if="statisticsCompliancePercentage < 100">
                                                                            <b-progress-bar locale="en" :value="statisticsCompliancePercentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                            <b-progress-bar locale="en" :value="statisticsCompliancePercentageRemaining" :precision="2" show-value type="is-danger"></b-progress-bar>
                                                                        </template>
                                                                        <template #bar v-else>
                                                                            <b-progress-bar locale="en" :value="statisticsCompliancePercentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                        </template>
                                                                    </b-progress>
                                                                </div>
                                                                <div class="column has-text-right">
                                                                    <span style="font-weight: bold; font-size: x-large">{{statisticsActualSubmittedNotificationCount}} {{notificationPortalViewerNotificationSubmittedLabel}}</span>
                                                                </div>
                                                            </div>
                                                            <b-table :data="statisticsCompliances">
                                                                <b-table-column v-if="partyId == null" field="year" :label="yearLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-5percent'}))"  v-slot="props">
                                                                    {{ props.row.year }}
                                                                </b-table-column>
                                                                <b-table-column v-else field="year" :label="yearLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-50percent'}))"  v-slot="props">
                                                                    {{ props.row.year }}
                                                                </b-table-column>
                                                                <b-table-column v-if="partyId == null" :label="statusLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-20percent'}))" v-slot="props">
                                                                    <b-progress size="is-large" format="percent" :max="100" locale="en" v-if="!props.row.exempted">
                                                                        <template #bar v-if="props.row.percentage < 100">
                                                                            <b-progress-bar locale="en" :value="props.row.percentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                            <b-progress-bar locale="en" :value="props.row.remaining" :precision="2" show-value type="is-danger"></b-progress-bar>
                                                                        </template>
                                                                        <template #bar v-else>
                                                                            <b-progress-bar locale="en" :value="props.row.percentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                        </template>
                                                                    </b-progress>
                                                                </b-table-column>
                                                                <b-table-column v-else :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-30percent'}))" v-slot="props">
                                                                    <a v-if="props.row.compliance == 1" href="#" @click.prevent="loadNotificationPortalInfo(150, partyId, props.row.periodId, true, true)">
                                                                        <i class="fas fa-check-circle primary-text"></i>
                                                                    </a>
                                                                    <i v-if="props.row.compliance == -1" class="fas fa-circle has-text-danger"></i>
                                                                </b-table-column>
                                                                <b-table-column v-if="partyId == null" :label="notificationsLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-10percent'}))" v-slot="props">
                                                                    <div v-if="!props.row.exempted">
                                                                        <span style="font-weight: bold">{{props.row.submitted}}</span> / {{props.row.total}}
                                                                    </div>
                                                                </b-table-column>
                                                                <b-table-column v-if="partyId == null" :label="submittedLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-30percent'}))" v-slot="props">
                                                                    {{ props.row.compliants }}
                                                                </b-table-column>
                                                                <b-table-column v-if="partyId == null" :label="notSubmittedLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-20percent'}))" v-slot="props">
                                                                    <div v-if="!props.row.exempted">
                                                                        <span v-if="!props.row.exempted">{{props.row.nonCompliants}}</span>
                                                                    </div>
                                                                </b-table-column>
                                                            </b-table>                                                            
                                                        </template>
                                                    </b-tab-item>
                                                    <b-tab-item>
                                                        <template #header>
                                                            <span>
                                                                {{notificationPortalProcurementHeaderLabel}}
                                                                <b-tag rounded type="is-info" size="is-large"> {{thresholdCompliancePercentagePrecision}}% </b-tag>
                                                            </span>
                                                        </template>
                                                        <template v-if="thresholdLoading"><loading></loading></template>
                                                        <template v-else>
                                                            <b-message type="is-success" class="mb-3">
                                                                {{notificationPortalThresholdObligationMessage}}
                                                            </b-message>
                                                            <div class="mb-2 columns">
                                                                <div class="column">
                                                                    <h6>{{notificationPortalviewerStatusNotificationSubmittedLabel}}</h6>
                                                                    <b-progress size="is-large" format="percent" :max="100" locale="en" class="mb-5">
                                                                        <template #bar v-if="thresholdCompliancePercentage < 100">
                                                                            <b-progress-bar locale="en" :value="thresholdCompliancePercentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                            <b-progress-bar locale="en" :value="thresholdCompliancePercentageRemaining" :precision="2" show-value type="is-danger"></b-progress-bar>
                                                                        </template>
                                                                        <template #bar v-else>
                                                                            <b-progress-bar locale="en" :value="thresholdCompliancePercentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                        </template>
                                                                    </b-progress>
                                                                </div>
                                                                <div class="column has-text-right">
                                                                    <span style="font-weight: bold; font-size: x-large">{{thresholdActualSubmittedNotificationCount}} {{notificationPortalViewerNotificationSubmittedLabel}}</span>
                                                                </div>
                                                            </div>
                                                            <b-table :data="thresholdCompliances">
                                                                <b-table-column v-if="partyId == null" field="year" :label="yearLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-5percent'}))"  v-slot="props">
                                                                    {{ props.row.year }}
                                                                </b-table-column>
                                                                <b-table-column v-else field="year" :label="yearLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-50percent'}))"  v-slot="props">
                                                                    {{ props.row.year }}
                                                                </b-table-column>
                                                                <b-table-column v-if="partyId == null" :label="statusLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-20percent'}))" v-slot="props">
                                                                    <b-progress size="is-large" format="percent" :max="100" locale="en" v-if="!props.row.exempted">
                                                                        <template #bar v-if="props.row.percentage < 100">
                                                                            <b-progress-bar locale="en" :value="props.row.percentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                            <b-progress-bar locale="en" :value="props.row.remaining" :precision="2" show-value type="is-danger"></b-progress-bar>
                                                                        </template>
                                                                        <template #bar v-else>
                                                                            <b-progress-bar locale="en" :value="props.row.percentage" :precision="2" show-value type="is-success"></b-progress-bar>
                                                                        </template>
                                                                    </b-progress>
                                                                </b-table-column>
                                                                <b-table-column v-else :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-20percent'}))" v-slot="props">
                                                                    <a v-if="props.row.compliance == 1" href="#" @click.prevent="loadNotificationPortalInfo(244, partyId, props.row.periodId, true, true)">
                                                                        <i class="fas fa-check-circle primary-text"></i>
                                                                    </a>
                                                                    <i v-if="props.row.compliance == -1" class="fas fa-circle has-text-danger"></i>
                                                                </b-table-column>
                                                                <b-table-column v-if="partyId == null" :label="notificationsLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-10percent'}))" v-slot="props">
                                                                    <div v-if="!props.row.exempted">
                                                                        <span style="font-weight: bold">{{props.row.submitted}}</span> / {{props.row.total}}
                                                                    </div>
                                                                </b-table-column>
                                                                <b-table-column v-if="partyId == null" :label="submittedLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-30percent'}))" v-slot="props">
                                                                    {{ props.row.compliants }}
                                                                </b-table-column>
                                                                <b-table-column v-if="partyId == null" :label="notSubmittedLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-20percent'}))" v-slot="props">
                                                                    <div v-if="!props.row.exempted">
                                                                        <span v-if="!props.row.exempted">{{props.row.nonCompliants}}</span>
                                                                    </div>
                                                                </b-table-column>
                                                            </b-table>                                                            
                                                        </template>
                                                    </b-tab-item>
                                                </b-tabs>
                                            </div>
                                        </div>
                                    </b-tab-item>
                                    <b-tab-item :label="notificationPortalNonPeriodicHeaderLabel" v-if="partyId == null">
                                        <template v-if="nonPeriodicLoading"><loading></loading></template>
                                        <template v-else>
                                            <div class="columns">
                                                <div class="column mx-auto my-auto has-text-centered is-4">
                                                    <span style="font-weight: bolder; font-size: xxx-large;">{{overallNonPeriodicSubmittedNotificationCount}}</span>
                                                    <h6>{{notificationPortalViewerTotalNumberLabel}}</h6>
                                                </div>
                                                <div class="column is-8">
                                                    <bar-chart id="nonPeriodicBarChart" :width="400" :height="400" data-key="label" :data="nonPeriodicBarData"></bar-chart>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="columns">
                                            <div class="column">
                                                <b-tabs>
                                                    <b-tab-item>
                                                        <template #header>
                                                            <span> {{notificationPortalLegislationHeaderLabel}} <b-tag rounded type="is-info" size="is-large"> {{legislationSubmittedNotificationCount}}</b-tag> </span>
                                                        </template>
                                                        <template v-if="legislationLoading"><loading></loading></template>
                                                        <template v-else>
                                                            <b-message type="is-success" class="mb-3">
                                                                {{notificationPortalLegislationObligationMessage}}
                                                            </b-message>
                                                            <div class="columns">
                                                                <div class="column">
                                                                    <span style="font-weight: bolder; font-size: xx-large;">{{legislationSubmittedNotificationCount}}</span><span style="margin-left: 10px; font-weight: bold">{{notificationPortalViewerNotificationSubmittedLabel}}</span>
                                                                    <b-tooltip class="custom"
                                                                                type="is-success"
                                                                                :label="legislationTooltip"
                                                                                position="is-right"
                                                                                multilined>
                                                                        <b-icon size="is-small" icon="info-circle"></b-icon>
                                                                    </b-tooltip>
                                                                </div>
                                                            </div>
                                                            <b-table :data="legislationParties">
                                                                <b-table-column field="label" :label="partyLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-50percent'}))"  v-slot="props">
                                                                    {{ props.row.label }}
                                                                </b-table-column>
                                                                <b-table-column v-slot="props">
                                                                    <a v-if="props.row.submitted" href="#" @click.prevent="loadNotificationPortalInfo(178, props.row.id, 178, true, false)">
                                                                        <i class="fas fa-circle fa-duo" style="color: cornflowerblue"></i>
                                                                    </a>
                                                                </b-table-column>
                                                            </b-table>
                                                        </template>
                                                    </b-tab-item>
                                                    <b-tab-item>
                                                        <template #header>
                                                            <span> {{notificationPortalModificationHeaderLabel}} <b-tag rounded type="is-info" size="is-large"> {{modificationSubmittedNotificationCount}}</b-tag> </span>
                                                        </template>
                                                        <template v-if="modificationLoading"><loading></loading></template>
                                                        <template v-else>
                                                            <b-message type="is-success" class="mb-3">
                                                                {{notificationPortalModificationObligationMessage}}
                                                            </b-message>
                                                            <div class="columns">
                                                                <div class="column">
                                                                    <span style="font-weight: bolder; font-size: xx-large;">{{modificationSubmittedNotificationCount}}</span><span style="margin-left: 10px; font-weight: bold">{{notificationPortalViewerNotificationSubmittedLabel}}</span>
                                                                    <b-tooltip class="custom"
                                                                                type="is-success"
                                                                                :label="modificationTooltip"
                                                                                position="is-right"
                                                                                multilined>
                                                                        <b-icon size="is-small" icon="info-circle"></b-icon>
                                                                    </b-tooltip>
                                                                </div>
                                                            </div>
                                                            <b-table :data="modificationParties">
                                                                <b-table-column field="label" :label="partyLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-50percent'}))"  v-slot="props">
                                                                    {{ props.row.label }}
                                                                </b-table-column>
                                                                <b-table-column v-slot="props">
                                                                    <a v-if="props.row.submitted" href="#" @click.prevent="loadNotificationPortalInfo(245, props.row.id, 245, true, false)">
                                                                        <i class="fas fa-circle fa-duo" style="color: cornflowerblue"></i>
                                                                    </a>
                                                                </b-table-column>
                                                            </b-table>                                                            
                                                        </template>
                                                    </b-tab-item>
                                                    <b-tab-item>
                                                        <template #header>
                                                            <span> {{notificationPortalPublicationMediaHeaderLabel}} <b-tag rounded type="is-info" size="is-large"> {{publicationMediaSubmittedNotificationCount}}</b-tag> </span>
                                                        </template>
                                                        <template v-if="publicationMediaLoading"><loading></loading></template>
                                                        <template v-else>
                                                            <b-message type="is-success" class="mb-3">
                                                                {{notificationPortalPublicationMediaObligationMessage}}
                                                            </b-message>
                                                            <div class="columns">
                                                                <div class="column">
                                                                    <span style="font-weight: bolder; font-size: xx-large;">{{publicationMediaSubmittedNotificationCount}}</span><span style="margin-left: 10px; font-weight: bold">{{notificationPortalViewerNotificationSubmittedLabel}}</span>
                                                                    <b-tooltip class="custom"
                                                                                type="is-success"
                                                                                :label="publicationMediaTooltip"
                                                                                position="is-right"
                                                                                multilined>
                                                                        <b-icon size="is-small" icon="info-circle"></b-icon>
                                                                    </b-tooltip>
                                                                </div>
                                                            </div>
                                                            <b-table :data="publicationMediaParties">
                                                                <b-table-column field="label" :label="partyLabel" :th-attrs="((row,column) => ({ class: 'has-text-weight-bold table-width-50percent'}))"  v-slot="props">
                                                                    {{ props.row.label }}
                                                                </b-table-column>
                                                                <b-table-column v-slot="props">
                                                                    <a v-if="props.row.submitted" href="#" @click.prevent="loadNotificationPortalInfo(246, props.row.id, 246, true, false)">
                                                                        <i class="fas fa-circle fa-duo" style="color: cornflowerblue"></i>
                                                                    </a>
                                                                </b-table-column>
                                                            </b-table>                                                            
                                                        </template>
                                                    </b-tab-item>
                                                </b-tabs>
                                            </div>
                                        </div>
                                    </b-tab-item>
                                    <b-tab-item v-else :label="notificationPortalNonPeriodicHeaderLabel">
                                        <template v-if="nonPeriodicLoading"><loading></loading></template>
                                        <template v-else>                                            
                                            <div class="columns">
                                                <div class="column mx-auto my-auto has-text-centered is-4">
                                                    <span style="font-weight: bolder; font-size: xxx-large;">{{overallNonPeriodicSubmittedNotificationCount}}</span>
                                                    <h6>{{notificationPortalViewerTotalNumberLabel}}</h6>
                                                </div>
                                                <div class="column is-8">
                                                    <div class="table-wrapper has-mobile-cards">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    <th>{{notificationsLabel}}</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <b-tooltip class="custom"
                                                                                    type="is-success"
                                                                                    :label="legislationTooltip"
                                                                                    position="is-left"
                                                                                    multilined>
                                                                            <b-icon size="is-small" icon="info-circle"></b-icon>
                                                                        </b-tooltip>
                                                                        {{notificationPortalLegislationHeaderLabel}}
                                                                    </td>
                                                                    <td align="center">
                                                                        <a v-if="legislationSubmittedNotificationCount > 0" href="#" @click.prevent="loadNotificationPortalInfo(178, partyId, 178, true, false)">
                                                                            <i class="fas fa-circle fa-duo" style="color: cornflowerblue"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <b-tooltip class="custom"
                                                                                    type="is-success"
                                                                                    :label="modificationTooltip"
                                                                                    position="is-left"
                                                                                    multilined>
                                                                            <b-icon size="is-small" icon="info-circle"></b-icon>
                                                                        </b-tooltip>
                                                                        {{notificationPortalModificationHeaderLabel}}
                                                                    </td>
                                                                    <td align="center">
                                                                        <a v-if="modificationSubmittedNotificationCount > 0" href="#" @click.prevent="loadNotificationPortalInfo(245, partyId, 245, true, false)">
                                                                            <i class="fas fa-circle fa-duo" style="color: cornflowerblue"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <b-tooltip class="custom"
                                                                                    type="is-success"
                                                                                    :label="publicationMediaTooltip"
                                                                                    position="is-left"
                                                                                    multilined>
                                                                            <b-icon size="is-small" icon="info-circle"></b-icon>
                                                                        </b-tooltip>
                                                                        {{notificationPortalPublicationMediaHeaderLabel}}
                                                                    </td>
                                                                    <td align="center">
                                                                        <a v-if="publicationMediaSubmittedNotificationCount > 0" href="#" @click.prevent="loadNotificationPortalInfo(246,  partyId, 246, true, false)">
                                                                            <i class="fas fa-circle fa-duo" style="color: cornflowerblue"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>                                                                                                        
                                                </div>
                                            </div>
                                        </template>
                                    </b-tab-item>
                                </b-tabs>
                            </div>
                        </div>
                    </section>
                    <b-message type="is-info" v-else>
                        {{notificationPortalInfoMessage}} <b-button v-if="showRefetch" type="is-link is-primary" style="float: right;" @click="loadNotificationData(true, true)">{{notificationPortalViewerRefreshDataLabel}}</b-button>
                    </b-message>
                </div>
                <b-modal id="notificationModal" ref="notificationModal" v-model="showNotificationModal" #default="props" :can-cancel="['x']">
                    <div class="modal-card" style="overflow-y: auto;">
                        <header class="modal-card-head">
                            <p class="modal-card-title">{{notificationModalTitle}}</p>
                            <button type="button" class="delete" @click="closeModal" />
                        </header>
                        <section class="modal-card-body">
                            <div class="card" v-if="showIndividualNotificationPortalInfo">
                                <div class="card-content">
                                    <h1 class="has-text-weight-bold">{{notificationRequirement}}</h1>
                                    <b-table :data="notificationInfos">
                                        <b-table-column :label="notificationSymbolLabel"  v-slot="props">
                                            <a :href="props.row.notificationSymbolLink" target="_blank">
                                                {{props.row.notificationSymbol}}
                                            </a>
                                        </b-table-column>
                                        <b-table-column :label="communicationDateLabel"  v-slot="props">
                                            {{props.row.communicationDate}}
                                        </b-table-column>
                                        <b-table-column label="Coverage" v-if="showCoverageDates"  v-slot="props">
                                            {{props.row.coverage}}
                                        </b-table-column>
                                    </b-table>                                    
                                </div>
                            </div>
                            <b-message type="is-info" v-else>
                                {{individualNotificationPortalInfoMessage}} <b-button v-if="showRefetchOnModal" type="is-link is-primary" style="float: right;" @click="loadNotificationPortalInfo(individualRequirementId, individualPartyId, individualPeriodId, false, forPeriodic)">{{notificationPortalViewerRefreshDataLabel}}</b-button>
                            </b-message>
                        </section>
                    </div>
                </b-modal>
            </div>
	`
});